import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const page = usePage()

const latestAssessments = computed<Array<{id: number; title: string;}>>(() => {
    return page.props.latestAssessments as Array<{id: number; title: string;}>
})

export const useAssessment = () => {
    return {
        latestAssessments
    }
}
